import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW1311Model } from './kymw1311.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { OrderCodeTextInputComponent } from '../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';
import { ClassificationsListComponent } from '../../../commons/kymw02/list/classifications-list/classifications-list.component';
import { CodeListComponent } from '../../../commons/kymw02/list/code-list/code-list.component';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { OutputPlanDutiesFormCSVService } from './api-services/output-plan-duties-form-csv.service';
import { KYMW1311CatalogDataCsvModel } from './vo/kymw1311-catalog-data-csv.model';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';

/**
 * 業態別企画書データ出力画面を管理するクラス
 *
 * @export KYMW1311Component
 * @class KYMW1311Component
 */
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-kymw1311',
  templateUrl: 'kymw1311.component.html',
  styleUrls: ['kymw1311.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1311Component extends PlessViewHelperSub implements OnInit {

  @ViewChild('txti_OrderCodeFrom', { static: true }) txti_OrderCodeFrom: OrderCodeTextInputComponent;
  @ViewChild('txti_OrderCodeTo', { static: true }) txti_OrderCodeTo: OrderCodeTextInputComponent;
  @ViewChild('lst_Classifications', { static: true }) lst_Classifications: ClassificationsListComponent;
  @ViewChild('lst_duties_daily', { static: true }) lst_duties_daily: CodeListComponent;

  // 親画面からの連携値
  param: any;

  kymw1311Model: KYMW1311Model = new KYMW1311Model();
  /**
   *Creates an instance of KYMW1311Component.
   * @param {PlessDialogService} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1311Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private fileDownloadConfirmService: FileDownloadConfirmService,
    private outputPlanDutiesFormCSVService: OutputPlanDutiesFormCSVService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1311Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1311';
  }

  public eventOut_CLICKHandler(): void {
    // 入力チェック
    if (this.inputCheck() === false) {
      return;
    }

    const reqVO: KYMW1311CatalogDataCsvModel = this.createCatalogDataCsvVO();

    // 業態別企画書データ出力API呼び出し
    this.outputPlanDutiesFormCSVService.execute(this.kymw1311Model, reqVO,
      (data: any) => this.outputPlanDutiesFormCSVServiceSuccessFunc(data));
  }

  /**
   * 入力チェック
   *
   * @return true:OK false:NG
   */
  private inputCheck(): boolean {
    let replaceArray: Array<string> = new Array<string>();

    // 必須チェック： 受注コード(From)
    if (PlessViewUtilsSub.isEmpty(this.kymw1311Model.orderCodeFrom)) {
      this.dialogService.openAlertGetMessage('W0001', ['受注コード(From)'], () => { });
      return false;
    }

    // 必須チェック： 受注コード(To)
    if (PlessViewUtilsSub.isEmpty(this.kymw1311Model.orderCodeTo)) {
      this.dialogService.openAlertGetMessage('W0001', ['受注コード(To)'], () => { });
      return false;
    }

    // 妥当性チェック：受注コード(From)
    if (!this.txti_OrderCodeFrom.isValidOrderCode()) {
      this.dialogService.openAlertGetMessage('W0024', ['受注コード(From)'], () => { });
      return false;
    }

    // 妥当性チェック：受注コード(To)
    if (!this.txti_OrderCodeTo.isValidOrderCode()) {
      this.dialogService.openAlertGetMessage('W0024', ['受注コード(To)'], () => { });
      return false;
    }

    // 受注コード大小チェック
    if (this.kymw1311Model.orderCodeFrom > this.kymw1311Model.orderCodeTo) {
      replaceArray = new Array<string>();
      replaceArray.push('受注コード(From)');
      replaceArray.push('受注コード(To)');

      this.dialogService.openAlertGetMessage('E0125', replaceArray, () => { });
      return false;
    }

    // 必須チェック： 部門コード
    if (PlessViewUtilsSub.isEmptyArray(this.lst_Classifications.selectedItems)) {
      this.dialogService.openAlertGetMessage('W0001', ['部門コード'], () => { });
      return false;
    }

    return true;
  }

  /**
   * 業態別企画書データ出力VO初期化
   *
   * @private
   * @returns {KYMW1311CatalogDataCsvModel}
   * @memberof KYMW1301Component
   */
  private createCatalogDataCsvVO(): KYMW1311CatalogDataCsvModel {
    const returnVO: KYMW1311CatalogDataCsvModel = new KYMW1311CatalogDataCsvModel();
    const classList: Array<string> = new Array<string>();                            // 選択部門コードリスト
    const dailyList: Array<string> = new Array<string>();                            // 選択業態区分（デイリー）リスト

    // 選択部門コードリストを取得
    for (const item of this.lst_Classifications.selectedItems) {
      classList.push(item);
    }

    // 選択業態区分（デイリー）リストを取得
    if (!PlessViewUtilsSub.isEmptyArray(this.lst_duties_daily.selectedItems)) {
      for (const item of this.lst_duties_daily.selectedItems) {
        dailyList.push(item);
      }
    }

    returnVO.orderCodeFrom = this.kymw1311Model.orderCodeFrom;
    returnVO.orderCodeTo = this.kymw1311Model.orderCodeTo;
    returnVO.mediumType = this.kymw1311Model.mediumType;
    returnVO.classificationsList = classList;
    returnVO.pCode = this.kymw1311Model.pCode;
    returnVO.dutiesFormDailyDivList = dailyList;

    if (this.kymw1311Model.dutiesWeeklyFlag) {
      returnVO.dutiesWeeklyFlag = PlessViewUtilsSub.booleanTOString(this.kymw1311Model.dutiesWeeklyFlag);
    }
    if (this.kymw1311Model.dutiesSpotFlag) {
      returnVO.dutiesSpotFlag = PlessViewUtilsSub.booleanTOString(this.kymw1311Model.dutiesSpotFlag);
    }

    return returnVO;
  }

  /**
   * 業態別企画書データ出力API成功処理
   *
   * @param {*} data APIレスポンス
   * @memberof KYMW1301Component
   */
  public outputPlanDutiesFormCSVServiceSuccessFunc(data: any) {
    // ファイル名の設定
    const fileName = '業態別企画書データ_' + PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss') + '.CSV';

    // ファイルダウンロード
    this.fileDownloadConfirmService.show(data.FileName, fileName);
  }
}
